<template>
  <div class="model-configuration-form">
    <p v-if="isSalesRep"><a href="/company-portal/sales-rep-landing"><strong><i class="fa fa-arrow-left" aria-hidden="true"></i> Back to Sales Rep Landing Page</strong></a></p>
    <div v-if="productCount > 0">
      <h3 class="h4">Configurations</h3>
      <p>Select your configurations below to see the price and lead time, and to add the product to your cart.</p>
      <div class="alert alert-success" role="alert" v-if="successMessage !== ''" v-html="successMessage"></div>
      <div class="alert alert-danger" role="alert" v-if="errorMessage !== ''">{{ errorMessage }}</div>
      <div class="form-group" v-for="(option) in options" :key="option.key">
        <label :for="option.key">{{ option.label }}</label>
        <select v-if="selected[option.key] === '' && option.values.length > 1" v-model="selected[option.key]" :id="option.key" class="form-control">
          <option value="">Select One</option>
          <option v-for="(value) in option.values" :key="value" :value="value">{{ value }}</option>
        </select>
        <div v-else-if="selected[option.key] === '' && option.values.length === 1" class="form-control selected-option">{{ option.values[0] }}</div>
        <div v-else class="form-control selected-option">{{ selected[option.key] }} <a @click="resetSelect(option.key)"><i class="fa fa-times" aria-hidden="true"></i></a></div>
      </div>
      <div v-if="product !== null">
        <h4 class="h5 part_number" v-if="showPartNumber">
          <span>{{ product.part_number }}</span>
          <input type="text" id="product-part-number" :value="product.part_number">
          <a @click="copyPartNumber()" title="Copy Part Number to Clipboard"><i id="copy-part-number-icon" class="fa fa-clipboard" aria-hidden="true"></i></a>
        </h4>
        <h4 class="h5" v-html="product.description"></h4>
        <div v-if="!isSalesRep" class="form-group">
          <label for="quantity">Quantity</label>
          <input type="number" v-model="quantity" id="quantity" min="1" class="form-control" />
        </div>
        <div v-if="!isSalesRep" class="callout-box">
          <div class="form-group prices">
            <div v-if="product.customer_price" class="customer-price">${{ product.customer_price }}</div>
            <div class="customer-price base-price">${{ product.base_price }}</div>
          </div>
          <p v-if="product.lead_time" class="h5" v-html="product.lead_time"></p>
        </div>
        <p v-if="!showPartNumber && !companyId">You may qualify for lower pricing by establishing an account with Holland Supply. <a href="/login">Login in or Create an account here.</a></p>
      </div>
      <p v-else>{{ productCount }} products match your selections. To find a specific product you can select additional options or request a quote for help finding what you need.</p>
      <div v-if="!isSalesRep" class="form-group form-actions">
        <div v-if="canPurchase && product !== null"><a @click="addToCart()" class="btn-gradient">Add To Cart</a></div>
        <div v-else><a @click="requestQuote()" class="btn-gradient">Request a Quote</a></div>
      </div>
    </div>
    <div v-else><a @click="requestQuote()" class="btn-gradient">Request a Quote</a></div>
  </div>
</template>

<script>
/* global pageUrl, modelName, modelId */

export default {
  name: 'ModelConfiguration',
  data () {
    return {
      pageUrl: pageUrl,
      modelName: modelName,
      modelId: modelId,
      companyId: null,
      canPurchase: false,
      showPartNumber: false,
      isSalesRep: false,
      options: [],
      selected: {},
      quantity: 1,
      product: null,
      productCount: 0,
      successMessage: '',
      errorMessage: ''
    }
  },
  created: function () {
    this.getUserVariables()
  },
  watch: {
    selected: {
      deep: true,
      handler () {
        this.getConfigurations()
      }
    }
  },
  methods: {
    getUserVariables () {
      const rootObj = this

      fetch('/get-user-permissions')
        .then(response => response.json())
        .then(function (json) {
          rootObj.companyId = json.companyId
          rootObj.canPurchase = json.canPurchase
          rootObj.showPartNumber = json.showPartNumber
          rootObj.isSalesRep = json.salesRep
        })
        .then(function () {
          if (rootObj.isSalesRep) {
            // hide everything that sales reps don't want to see
            document.getElementsByClassName('hide-for-sales-reps')[0].style.display = 'none'
          }
          rootObj.getConfigurations()
        })
        .catch(function (err) {
          // eslint-disable-next-line
          console.log(err)
        })
    },
    async getConfigurations () {
      var postData = JSON.stringify({ show_all: this.isSalesRep, model_id: this.modelId, company_id: this.companyId, selected: this.selected })
      var rootObj = this

      fetch(
        '/get-model-configurations',
        {
          method: 'POST',
          body: postData,
          headers: { 'Content-type': 'application/json; charset=UTF-8' }
        }
      )
        .then(response => response.json())
        .then(function (json) {
          rootObj.options = json.options
          json.options.forEach(function (option) {
            if (!Object.prototype.hasOwnProperty.call(rootObj.selected, option.key)) {
              rootObj.selected[option.key] = ''
            }
          })
          rootObj.productCount = json.product_count
          rootObj.product = json.product
        })
        .catch(function (err) {
          // eslint-disable-next-line
          console.log(err)
        })
    },
    resetSelect (key) {
      this.selected[key] = ''
    },
    requestQuote () {
      var selectedObj = this.selected
      var selectString = Object.keys(selectedObj).map(function (key) {
        return key + ' = ' + selectedObj[key]
      }).join(', ')

      var formData = { page_url: this.pageUrl, model_name: this.modelName, product_selected: (this.product !== null) ? this.product.itemid : '', options_selected: selectString }
      var queryString = new URLSearchParams(formData).toString()
      window.location = '/request-quote?' + queryString
    },
    addToCart () {
      this.successMessage = ''
      this.errorMessage = ''

      var postData = JSON.stringify({ product_id: this.product.id, qty: this.quantity })
      var rootObj = this

      fetch(
        '/add-to-cart',
        {
          method: 'POST',
          body: postData,
          headers: { 'Content-type': 'application/json; charset=UTF-8' }
        }
      )
        .then(response => response.json())
        .then(function (json) {
          if (json.success) {
          // reset the selections
            Object.keys(rootObj.selected).forEach(function (key) {
              rootObj.selected[key] = ''
            })
            rootObj.quantity = 1

            rootObj.successMessage = 'Your product has been added to the cart. <a href="/cart">View Cart</a>'

            // scroll the user to the top
            const yOffset = -100
            const element = document.getElementById('modelConfigurations')
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset
            window.scrollTo({ top: y, behavior: 'smooth' })
            // eslint-disable-next-line
            updateCartCount()
          } else {
          // add the error message
            if (json.error.length > 0) {
              rootObj.errorMessage = json.error
            } else {
              rootObj.errorMessage = 'An unspecified error occurred, please try again.'
            }
          }
        })
        .catch(function (err) {
          // eslint-disable-next-line
          console.log(err)
        })
    },
    copyPartNumber () {
      const icon = document.getElementById('copy-part-number-icon')
      const partNumber = document.getElementById('product-part-number')
      partNumber.select()

      try {
        var successful = document.execCommand('copy')
        if (successful) {
          icon.classList.remove('fa-clipboard')
          icon.classList.add('fa-check')
          setTimeout(function () {
            icon.classList.remove('fa-check')
            icon.classList.add('fa-clipboard')
          }, 1000)
        }
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }

      window.getSelection().removeAllRanges()
    }
  }
}
</script>
